import {multipleChoiceSetup} from './questionTypes/multipleChoiceQuestion.extensions';
import {fillInTheBlankSetup} from './questionTypes/fillInTheBlankQuestion.extensions';
import {freeEntrySetup} from './questionTypes/freeEntryQuestion.extensions';
import {snippetSelectionSetup} from './questionTypes/snippetSelectionQuestion.extensions';
import {twoWaySetup} from './questionTypes/twoWayQuestion.extensions';

export function questionTypeSetup(data) {
  // admin-locked-assessments: a content-locked question has its type-specific content
  // (options / dropdowns / rows / …) redacted to null by the backend. The per-type setups below map
  // over those fields and would null-deref, failing model construction and dropping the question on
  // hydration before anything renders. Skip the transforms for a locked question; the block-and-
  // message (teacher Parts 2/3, student Part 4 #17843) renders from is_content_locked instead.
  if (data.get('is_content_locked')) {
    return data;
  }
  const questionType = data.get('question_type');
  let setupData = data;
  if (questionType === 'multiple-choice') {
    setupData = multipleChoiceSetup(data);
  } else if (questionType === 'fill-in-the-blank') {
    setupData = fillInTheBlankSetup(data);
  } else if (questionType === 'free-entry') {
    setupData = freeEntrySetup(data);
  } else if (questionType === 'snippet-selection') {
    setupData = snippetSelectionSetup(data);
  } else if (questionType === 'two-way') {
    setupData = twoWaySetup(data);
  }
  // Text highlight questions do not transform their data
  return setupData;
}
